
import { defineComponent } from 'vue'
import { Skeletor } from 'vue-skeletor'

export default defineComponent({
  components: { Skeletor },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
      default: false,
    },
    itemHeight: {
      type: Number,
      default: 32,
    },
    itemWidth: {
      type: Number,
      default: 32,
    },
    itemDistance: {
      type: Number,
      default: 4,
    },
  },
})
